import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';

import AgGridReactComponent from '../../../../common/components/ag-grid-react-component';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { formatGivenDate } from '../../../../shared/services/common-functions';

function onGridReady(params) {
    setTimeout(() => {
        params.api.sizeColumnsToFit();
    }, 500);
}

function buildWeekSetter ( buildWk ) {

    const itemBuildWk = formatGivenDate( buildWk, 'YYYY-MM-DD' );

    if ( itemBuildWk === '' ) return ( <span>{itemBuildWk}</span> );
    if ( itemBuildWk === '2000-01-01' ) {

        return 'Inventory';

    } if ( itemBuildWk === '2000-02-01' ) {

        return 'Rework';

    }
    return itemBuildWk;

}

const colDefs = [
    {
        field: 'model',
        headerName: 'Model',
        width: 60,
        colSpan ( params ) {

            return ( params.data.model === '0' ) ? 8 : 1;

        },
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            if ( params.value === '0' ) {

                return ( <span className="totalMessage">{params.data.message}</span> );

            }
            return ( <span>{params.value}</span> );

        }
    },
    {
        field: 'orderNum',
        headerName: 'Order Number',
        width: 85,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            return ( <Link to={`/${params.data.unitName}/order/information?ordernum=${params.value}`}>{params.value}</Link> );

        }
    },
    {
        field: 'requiredDD',
        headerName: 'RDD',
        width: 70,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MMM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'factDD',
        headerName: 'FDD',
        width: 70,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MMM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'buildWeek',
        headerName: 'Build Week',
        width: 70,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MMM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'reqstShipDate',
        headerName: 'RSD',
        width: 70,
        cellRenderer: params => {

            if ( params.value === '' ) return ( <span>{params.value}</span> );
            const dt = formatGivenDate( params.value, 'YYYY-MMM-DD' );
            return ( <span>{dt}</span> );

        }
    },
    {
        field: 'linkedOrdIND',
        headerName: 'Linked Ord Ind',
        width: 70
    },
    {
        field: 'earlyShipIND',
        headerName: 'Early Ship Ind',
        width: 70
    }
];

const OrdersUsingBundlesTable = props => (
    <section className="atp-search-result-panel order-using-bundles-panel ">
        <div className="buildWk"> Build Week: {buildWeekSetter( props.buildWeek )} </div>

        <AgGridReactComponent
            reactNext={true}
            columnDefs={colDefs}
            rowData={props.results}
            onGridReady={onGridReady}
        />
    </section>
);

OrdersUsingBundlesTable.propTypes = {
    results: PropTypes.array.isRequired,
    buildWeek: PropTypes.number
};
export default OrdersUsingBundlesTable;
